export type CostTab = 'products' | 'recipes' | 'rates'

interface CostTabsProps {
  value: CostTab
  onChange: (tab: CostTab) => void
  /** Сколько продуктов в корзине — цифра рядом с вкладкой. */
  productsCount: number
}

/** Подписи короткие: на телефоне три вкладки с «Мои …» не помещаются. */
const CostTabs = ({ value, onChange, productsCount }: CostTabsProps) => (
  <div className="cost-tabs" role="tablist">
    <button
      type="button"
      role="tab"
      aria-selected={value === 'products'}
      className={`cost-tabs__item ${value === 'products' ? 'active' : ''}`}
      onClick={() => onChange('products')}
    >
      Продукты
      {productsCount > 0 && (
        <span className="cost-tabs__count">{productsCount}</span>
      )}
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'recipes'}
      className={`cost-tabs__item ${value === 'recipes' ? 'active' : ''}`}
      onClick={() => onChange('recipes')}
    >
      Рецепты
    </button>
    <button
      type="button"
      role="tab"
      aria-selected={value === 'rates'}
      className={`cost-tabs__item ${value === 'rates' ? 'active' : ''}`}
      onClick={() => onChange('rates')}
    >
      Ставки
    </button>
  </div>
)

export default CostTabs
